<div class="rodape-container flex justify-between py-8">
  <div class="logo py-4">
    <a href="/">
      <img class="logo" id="logo-simcaq-vix" src="assets/ilustrations/simcaq_logo_complete.svg" alt="SIMCAQ">
    </a>
  </div>

  <div class="links-container">
    <div class="secao-conheca">
      <h3 class="text-heading-md text-regular text-red-500 m-0">Conheça</h3>
      <div class="flex flex-col items-center gap-2 mt-4">
        <a href="/sobre" class="text-body-md text-regular text-charcoal-800">Sobre</a>
        <a href="/equipe" class="text-body-md text-regular text-charcoal-800">Equipe</a>
        <a href="/contato" class="text-body-md text-regular text-charcoal-800">Contato</a>
        <a href="https://simcaq.ufg.br/assets/SIMCAQ_termos_de_uso.pdf" target="_blank" class="text-body-md text-regular text-charcoal-800">Termos de uso</a>
      </div>
    </div>

    <div class="secao-conteudos">
      <h3 class="text-heading-md text-regular text-red-500 m-0">Conteúdos</h3>
      <div class="flex flex-col items-center gap-2 mt-4">
        <a href="#" class="text-body-md text-regular text-charcoal-800">Publicações</a>
        <a href="#" class="text-body-md text-regular text-charcoal-800">Tutoriais</a>
      </div>
    </div>

    <div class="secao-consulta">
      <h3 class="text-heading-md text-regular text-red-500 m-0">Consulta</h3>
      <div class="consulta-colunas mt-4">
        <div class="flex flex-col gap-2">
          <a href="/planejamento-orcamentario-apresentacao" class="text-body-md text-regular text-charcoal-800">Orçamento para garantia de um padrão de qualidade</a>
          <a href="/financiamento-atual-necessario" class="text-body-md text-regular text-charcoal-800">Financiamento atual e necessário por ente federativo</a>
          <a href="/custo-por-escola-apresentacao" class="text-body-md text-regular text-charcoal-800">Custo das condições de qualidade por escola</a>
          <a href="/caq-apresentacao" class="text-body-md text-regular text-charcoal-800">Custo Aluno Qualidade por etapa/modalidade</a>
          <a *ngIf="featureFlagService.funcionalidadeHabilitada('885-tela-apresentacao-relatorio-receitas-despesas')"
             href="/relatorio-receitas-despesas-apresentacao" class="text-body-md text-regular text-charcoal-800">Receitas e Despesas da educação básica</a>
        </div>
        <div class="flex flex-col gap-2">
          <a href="assets/20260903_PQR_alterado.remuneracao_VF.pdf" target="_blank" class="text-body-md text-regular text-charcoal-800">Dimensões e justificativas</a>
          <a href="/pqr" class="text-body-md text-regular text-charcoal-800">Parâmetros para cálculo do CAQ</a>
          <a href="/qualidade" class="text-body-md text-regular text-charcoal-800">Concepção de educação de qualidade</a>
        </div>
      </div>
    </div>
  </div>
</div>
